import { Popover } from 'foundations-components/transitional/components/Popover';
import { useState } from 'react';
import { SmartPropertyCitationPanel } from '../SmartPropertyCitationPanel/SmartPropertyCitationPanel';
import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AsynCitationPopoverContent = Loadable({
  loader: () => import('./CitationPopoverContentContainer')
});
export const preloadSmartPropertyCitationPopover = async () => {
  await AsynCitationPopoverContent.preload();
};
export const SmartPropertyCitationPopover = ({
  smartPropertyResultId,
  open,
  onOpenChange,
  onOpenCitationPanel,
  children
}) => {
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const [defaultTab, setDefaultTab] = useState('activity');
  const handleOpenPanel = tab => {
    if (onOpenCitationPanel) {
      onOpenCitationPanel(smartPropertyResultId);
    } else {
      setIsPanelOpen(true);
    }
    setDefaultTab(tab);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Popover, {
      "data-test-id": "smart-property-citation-popover",
      closeOnOutsideClick: true,
      closeOnTargetLeave: true,
      content: /*#__PURE__*/_jsx(AsynCitationPopoverContent, {
        smartPropertyResultId: smartPropertyResultId,
        onOpenChange: onOpenChange,
        onOpenPanel: handleOpenPanel
      }),
      inlineSize: "360px",
      onOpenChange: onOpenChange,
      open: open,
      use: "longform",
      children: /*#__PURE__*/_jsx(_Fragment, {
        children: children
      })
    }), isPanelOpen && /*#__PURE__*/_jsx(SmartPropertyCitationPanel, {
      onClose: () => setIsPanelOpen(false),
      smartPropertyResultId: smartPropertyResultId,
      defaultTab: defaultTab
    })]
  });
};